/* EVERIDE mobile PLP behavior.
   Native Horizon drawer behavior is retained; this only sets a compact initial facet state. */

(() => {
  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  const compactFilterPanels = (drawer) => {
    if (!isMobile() || !(drawer instanceof HTMLElement) || drawer.id !== 'filters-drawer') return;

    drawer.querySelectorAll('details.facets__panel').forEach((panel) => {
      const checkedControl = panel.querySelector('input[type="checkbox"]:checked, input[type="radio"]:checked');
      const status = panel.querySelector('.facets__status');
      const statusText = status?.textContent?.trim() || '';
      const hasActiveState = Boolean(checkedControl || statusText);

      if (!hasActiveState) panel.removeAttribute('open');
    });
  };

  document.addEventListener('theme-drawer:open', (event) => {
    compactFilterPanels(event.target);
  });
})();
